// Output version number, so we can see it even in cases of error
import Constants from "./constants"
console.info(`GBuilder Smart Floor Plan ${Constants.VERSION_NO}`) 

import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import './localization/i18n'

createRoot(document.getElementById('root')).render(
     <App />
)